import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { OfferPopup } from "@/components/OfferPopup";
import { CallFab } from "@/components/CallFab";
import { RecapDrawer } from "@/components/RecapDrawer";
import { PostAddPanel } from "@/components/PostAddPanel";

export const PublicLayout = () => {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <OfferPopup />
      <CallFab />
      <RecapDrawer />
      <PostAddPanel />
    </div>
  );
};

export default PublicLayout;
